import { i18n } from '@/main.js'

export function transform(data, options = { isRange: false, returnElements: false }) {

    let dates;
    let dateStrings;
    let compositeString;
    let compositeArray;
    let rangeSeparator;
    let multipleSeparator;

    // Null check.
    if(!data) {
        throwError("No data was specified. Returning empty.");
        return "";
    }

		// Convert data to array and
		// sanitize dates by converting to appropriate type.
		if(typeof data === "string") {
        // console.log("this is string");
        dates = [new Date(data)];
    } else if (data instanceof Date) {
        // console.log("this is date");
        dates = [data];
    } else if (data instanceof Array && data.length) {
        // console.log("this is array");
        dates = data.map((date) => {
            if (date) {
                return new Date(date);
            } else {
                throwError(`Date ${date} is not valid.`)
            }
        });
    }

    if (options.isRange && dates.length !== 2) {
        throwError(`Can't calculate range if ${dates.length} dates were specified. Please specify exactly 2 (the first and last).`)
    }

    // Remove repeated dates.
    // dates = dates.filter((date: Date, index: number) => {
    // 	if (dates[index+1] && (date.getTime() === dates[index+1].getTime())) {
    // 		return true;
    // 	}
    // });

    // console.log("dates before checkin types", dates);

    // Get similarities and differences in dates type values.
    const similTypes = getDateTypesDifferences(dates).similar;
    const diffTypes = getDateTypesDifferences(dates).different;

    // console.log("similTypes", similTypes);
    // console.log("diffTypes", diffTypes);

    const separator = options.isRange ? rangeSeparator : multipleSeparator;

    //
    // Compose date string.
    //
    // console.log(`var dates has ${dates.length} dates and isRange is ${options.isRange}`);
    // Exactly one date
    if (dates.length === 1) {
        dateStrings = [getDateString(dates[0], evalYear(dates[0], ["d", "m", "y"]))];
        if (options.returnElements) {
            compositeString = `<time datetime=${getDateFormat(dates[0])}>${dateStrings[0]}</time>`;
        } else {
            compositeString = dateStrings[0];
        }
        // Multiple dates
    } else {
        dateStrings = dates.map((date) => {
            return getDateString(date, diffTypes);
        })

        if (options.returnElements) {
            compositeArray = dateStrings.map((dateStrings, index) => {
                return `<time datetime=${getDateFormat(dates[index])}>${dateStrings}</time>`;
            })
            compositeString = `${compositeArray.join(separator)} ${getDateString(dates[0], evalYear(dates[0], similTypes))}`;
        } else {
            compositeString = `${dateStrings.join(separator)} ${getDateString(dates[0], evalYear(dates[0], similTypes))}`;
        }
    }

    return compositeString;
}

/**
 * Evaluate if year is necessary.
 */
function evalYear(date, format) {
    const numberOfMonths = 6
    const today = new Date();
    const future = new Date(new Date().setMonth(today.getMonth() + numberOfMonths));

    // It's $numberOfMonths months from now, remove year.
    if((date.getTime() > today.getTime()) && (date.getTime() < future.getTime())) {
        format.splice(format.indexOf("y", 1))
        return format;
    } else {
        return format;
    }
}

/**
 * Returns a date in format ISO 8601 without time.
 */
function getDateFormat(date) {
    return date.toISOString().substring(0, 10);
}

/**
 * Returns array of similar and different date values
 * E.g.: ['my', 'd'] means dates are in the same month and year but
 * different days.
 */
function getDateTypesDifferences(dates) {

    let similTypes = ["d", "m", "y"];
    let diffTypes = [];

    const firstDateDay = dates[0].getDate();
    const firstDateMonth = dates[0].getMonth();
    const firstDateYear = dates[0].getFullYear();

    // Find different days.
    if(dates.find((date) => {
        let thisDateDay = date.getDate();

        if (firstDateDay !== thisDateDay) {
            return true;
        } else {
            return false;
        }
    })) {
    similTypes = ["m", "y"];
    diffTypes = ["d"];
    }

    // Find different months.
    if (dates.find((date) => {
        let thisDateMonth = date.getMonth();

        if (firstDateMonth !== thisDateMonth) {
            return true;
        } else {
            return false;
        }
    })) {
        similTypes = ["y"];
        diffTypes = ["d", "m"];
    }

    // Find different years.
    if (dates.find((date) => {
        let thisDateYear = date.getFullYear();

        if (firstDateYear !== thisDateYear) {
            return true;
        } else {
            return false;
        }
    })) {
        diffTypes = ["d", "m", "y"];
        similTypes = [];
    }

    return {
        similar: similTypes,
        different: diffTypes
    };
}

/**
 * Returns short month string.
 */
function getDateString(date, format) {
    if(date) {

        // Set variables.
        const d = date.toLocaleString(i18n.locale, { day: "numeric" })
        const m = date.toLocaleString(i18n.locale, { month: "short" })
        const y = date.toLocaleString(i18n.locale, { year: "numeric" });

        // Create array with values based on specified format.
        let compositeDateArray = format.map((item) => {
            return eval(item);
        })

        // Join array and return.
        return compositeDateArray.join(" ");

    } else {
        throwError("No date was specified in 'getDateString()'.")
    }
}

/**
 * Throw an error if transform is not well defined
 */
function throwError(error)
{
    throw Error(`TnsjDatePipe :: ${error || 'Some error occurred.'}`);
}


// WEBPACK FOOTER //
// ./src/data/helpers/date-pipe.js